import React, { useMemo } from "react";
import { Card, Row, Col, Descriptions } from "antd";
import * as DateFormater from "../../../../../utils/DateFormater";
import Telefone from "./Telefone";
import "./styles.css";
import { useOperators } from "../../../Contratos/use-operators";
import { NovoNumeroContratoField } from "./NovoNumeroContratoField";
import { NovoProdutoCarteiraField } from "./NovoProdutoCarteiraField";
import { NumeroClienteField } from "./NumeroClienteField";

const AcordoInfos = ({ acordo, onUpdate }) => {
  const { operadores, isLoading } = useOperators();
  console.log("operadores", operadores);

  const operadorNome = useMemo(() => {
    console.log("acordo", acordo);
    if (!acordo) return "-";

    // Se o backend já mandar o nome pronto, usa direto
    if (acordo.operador_nome) return acordo.operador_nome;

    // Se vier username separado
    if (acordo.operador_username) return acordo.operador_username;

    // Caso mais comum: vem apenas o ID do operador (FK)
    if (acordo.operador && Array.isArray(operadores) && operadores.length > 0) {
      const found = operadores.find((op) => op.id === acordo.operador);
      if (found) return found.name;
    }

    return "-";
  }, [acordo, operadores]);

  if (!acordo) return null;

  return (
    <div className="acordo-infos__container">
      <Row gutter={16}>
        {/* Card 1: Detalhes da Negociação */}
        <Col xs={24} md={8}>
          <Card
            size="small"
            title="Detalhes da Negociação"
            className="acordo-infos__card"
            style={{ borderRadius: "5px" }}
          >
            <Descriptions column={1} size="small">
              <Descriptions.Item label="Status Acordo">
                {acordo.status_acordo || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Tipo de Acordo">
                {acordo.tipo_acordo || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Data do Acordo">
                {acordo.data_acordo
                  ? DateFormater.format(acordo.data_acordo)
                  : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Tipo de Cobrança">
                {acordo.tipo_cobranca || "-"}
              </Descriptions.Item>
              {acordo.numero_processo && (
                <Descriptions.Item label="Nº Processo">
                  {acordo.numero_processo}
                </Descriptions.Item>
              )}
            </Descriptions>
          </Card>
        </Col>

        {/* Card 2: Informações do Cliente */}
        <Col xs={24} md={8}>
          <Card
            size="small"
            title="Informações do Cliente"
            className="acordo-infos__card"
            style={{ borderRadius: "5px" }}
          >
            <Descriptions column={1} size="small">
              <Descriptions.Item label="Cliente">
                {acordo.pessoa || acordo.cooperado || acordo.pasta || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="CPF/CNPJ">
                {acordo.cpf_cnpj || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Telefone">
                <Telefone telefone={acordo.telefone} acordo_id={acordo.id} />
              </Descriptions.Item>
              <Descriptions.Item label="Nº Cliente">
                <NumeroClienteField acordoId={acordo.id} value={acordo.numero_cliente} />
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>

        {/* Card 3: Informações Adicionais */}
        <Col xs={24} md={8}>
          <Card
            size="small"
            title="Informações Adicionais"
            className="acordo-infos__card"
            style={{ borderRadius: "5px" }}
          >
            <Descriptions column={1} size="small">
              <Descriptions.Item label="Operador">
                {isLoading ? "Carregando..." : operadorNome}
              </Descriptions.Item>

              {acordo.dias_em_atraso !== null &&
                acordo.dias_em_atraso !== undefined && (
                  <Descriptions.Item label="Dias em Atraso">
                    {acordo.dias_em_atraso}
                  </Descriptions.Item>
                )}

              {typeof acordo.participa_campanha === "boolean" && (
                <Descriptions.Item label="Campanha">
                  {acordo.participa_campanha
                    ? acordo.nome_campanha || "Sim"
                    : "Não"}
                </Descriptions.Item>
              )}

              <Descriptions.Item label="Novo Nº Contrato">
                <NovoNumeroContratoField acordoId={acordo.id} value={acordo.novo_numero_contrato} />
              </Descriptions.Item>

              <Descriptions.Item label="Nova Carteira/Produto">
                <NovoProdutoCarteiraField acordoId={acordo.id} value={acordo.novo_produto_carteira} />
              </Descriptions.Item>

              {acordo.notes && (
                <Descriptions.Item label="Observações">
                  {acordo.notes}
                </Descriptions.Item>
              )}
            </Descriptions>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AcordoInfos;



// WEBPACK FOOTER //
// ./src/pages/Pasta/Acordos/AcordoView/AcordoInfos/index.jsx